import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const ShopifySuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Extract OAuth callback data from URL params
    const clientPosId = searchParams.get("client_pos_id");
    const storeName = searchParams.get("store_name");
    const oauthSuccess = searchParams.get("oauth_success");

    if (oauthSuccess === "true" && clientPosId) {
      console.log("✅ OAuth callback successful, client_pos_id:", clientPosId, "store_name:", storeName);

      // Store the client_pos_id and store_name in sessionStorage for the configure page to retrieve
      sessionStorage.setItem("shopify_oauth_client_pos_id", clientPosId);
      sessionStorage.setItem("shopify_oauth_store_name", storeName || "");
      sessionStorage.setItem("shopify_oauth_timestamp", Date.now().toString());

      console.log("✅ Stored client_pos_id and store_name in sessionStorage");
    }
  }, [searchParams]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
        position: "fixed",
        top: 0,
        left: 0,
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        padding: "20px",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          background: "white",
          borderRadius: "20px",
          padding: "60px 40px",
          textAlign: "center",
          maxWidth: "500px",
          width: "100%",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.08)",
          backdropFilter: "blur(10px)",
          border: "1px solid rgba(255, 255, 255, 0.8)",
        }}
      >
        {/* Success Icon */}
        <CheckCircleIcon
          sx={{
            fontSize: "80px",
            color: "#10b981",
            marginBottom: "24px",
            animation: "pulse 2s infinite",
            "@keyframes pulse": {
              "0%, 100%": { opacity: 1 },
              "50%": { opacity: 0.7 },
            },
          }}
        />

        {/* Success Message */}
        <Typography
          sx={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#1f2937",
            marginBottom: "12px",
            letterSpacing: "-0.5px",
          }}
        >
          Connected!
        </Typography>

        {/* Subtitle */}
        <Typography
          sx={{
            fontSize: "16px",
            color: "#6b7280",
            marginBottom: "32px",
            lineHeight: "1.6",
            fontWeight: "500",
          }}
        >
          Your Shopify store has been successfully connected. You can now proceed to configure your POS settings.
        </Typography>

        {/* Continue Button */}
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/pos-sync/configure")}
          sx={{
            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
            color: "white",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: "600",
            padding: "12px 32px",
            borderRadius: "10px",
            border: "none",
            cursor: "pointer",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              boxShadow: "0 10px 25px rgba(16, 185, 129, 0.3)",
            },
          }}
        >
          Continue to POS Configuration
        </Button>
      </Box>
    </Box>
  );
};

export default ShopifySuccess;

